import { FC, memo } from 'react'
import { Box } from '@chakra-ui/react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
}

const OpenLetterOutline = createIcon({
  displayName: 'OpenLetterOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M18.75582,11V4.4a1.4,1.4,0,0,0-1.4-1.4h-11.2a1.4,1.4,0,0,0-1.4,1.4v6.46718"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M21.00025,11.66312a1,1,0,0,0-1.608-.79389l-6.15055,4.70993a2.04242,2.04242,0,0,1-2.48351,0s-3.88141-2.9723-6.15346-4.712A.99857.99857,0,0,0,3,11.66361V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2S21,14.41605,21.00025,11.66312Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path d="M0,0H24V24H0Z" fill="none" />
      <line x1="9" y1="7" x2="15" y2="7" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" />
      <line
        x1="9"
        y1="10"
        x2="15"
        y2="10"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const OpenLetterTwoTone = createIcon({
  displayName: 'OpenLetterTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <Box
        as="path"
        d="M18.75582,11V4.4a1.4,1.4,0,0,0-1.4-1.4h-11.2a1.4,1.4,0,0,0-1.4,1.4v6.46718"
        fill="none"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box
        as="path"
        d="M21.00025,11.66312a1,1,0,0,0-1.608-.79389l-6.15055,4.70993a2.04242,2.04242,0,0,1-2.48351,0s-3.88141-2.9723-6.15346-4.712A.99857.99857,0,0,0,3,11.66361V19a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2S21,14.41605,21.00025,11.66312Z"
        fill="twoToneFillColor"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path d="M0,0H24V24H0Z" fill="none" />
      <Box
        as="line"
        x1="9"
        y1="7"
        x2="15"
        y2="7"
        fill="twoToneFillColor"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box
        as="line"
        x1="9"
        y1="10"
        x2="15"
        y2="10"
        fill="twoToneFillColor"
        stroke="twoToneStrokeColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const OpenLetter: FC<CustomIconProps> = (props) => {
  if (props.variant === 'twoTone') return <CustomIcon as={OpenLetterTwoTone} {...props} />

  return <CustomIcon as={OpenLetterOutline} {...props} />
}

export default memo(OpenLetter)
